import React, { useState, useEffect } from 'react';
import styled, { css } from 'styled-components';
import { useHistory } from 'react-router-dom';

import SwapExchangesPanel from '../Components/SwapExchangesPanel';
import LatestTransactionsPanel from '../Components/LatestTransactionsPanel';
import YourPendingSwapsPanel from '../Components/YourPendingSwapsPanel';
import LoginModal from '../Components/LoginModal';
import CreateSwapModal from '../Components/CreateSwapModal';
import ProjectFieldColab from '../Components/ProjectFieldColab';
import TelegramButtonComponent from '../Components/TelegramButtonComponent';

import PlusSign from '../images/plusSign.png';
import BigImage from '../images/Illustration_IconSwap.svg';

import { useIconSwapService } from '../Components/IconSwapService.jsx';
import { Link } from 'react-router-dom';

export const Homepage = ({ showResponsiveLogin }: HomepagePropTypes) => {
  const history = useHistory();
  const { address } = useIconSwapService();
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const [isSwapModalOpen, setIsSwapModalOpen] = useState(false);

  useEffect(() => {
    getWindowDimensions();
    if (!address) return;
    closeAuthModal();
  }, [address]);

  const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  };
  const { innerWidth: width } = window;

  const openAuthModal = () => {
    setIsAuthModalOpen(true);
  };

  const openSwapModal = () => {
    setIsSwapModalOpen(true);
  };

  const closeAuthModal = () => {
    setIsAuthModalOpen(false);
  };

  const closeSwapModal = () => {
    setIsSwapModalOpen(false);
  };

  const chooseModal = () => {
    const { innerWidth: width } = window;
    if (width < 416) {
      return !address ? showResponsiveLogin() : history.push('/createSwap');
    }
    !address ? openAuthModal() : openSwapModal();
  };
  return (
    <>
      <HomepageWrapper width={width}>
        <HeaderComponent>
          <ContentWrapper>
            <PageTitle>Welcome to ICONswap</PageTitle>
            <TradeText>
              Safely trade and swap your IRC2 tokens, paired with ICX. What will
              you swap today?
            </TradeText>
            {width < 416 ? (
              <Link to="/createSwap" style={{ textDecoration: 'none' }}>
                <SwapButton onClick={() => {}}>
                  <PlusSignImage src={PlusSign} alt="plus sign"></PlusSignImage>
                  <ButtonText>Create a swap</ButtonText>
                </SwapButton>
              </Link>
            ) : (
              <SwapButton onClick={() => chooseModal()}>
                <PlusSignImage src={PlusSign} alt="plus sign"></PlusSignImage>
                <ButtonText>Create a swap</ButtonText>
              </SwapButton>
            )}
          </ContentWrapper>
          <BigImg src={BigImage} alt="Big image" />
        </HeaderComponent>
        <SwapExchangesPanel />
        <BottomPanelWrapper>
          <LatestTransactionsPanel
            token={'cxc0b5b52c9f8b4251a47e91dda3bd61e5512cd782'}
          />
          <YourPendingSwapsPanel createSwapModal={openSwapModal} />
        </BottomPanelWrapper>
        <ProjectFieldColab />
        <TelegramButtonComponent />
      </HomepageWrapper>
      <LoginModal isModalOpen={isAuthModalOpen} closeModal={closeAuthModal} />
      <CreateSwapModal
        isModalOpen={isSwapModalOpen}
        closeModal={closeSwapModal}
      />
    </>
  );
};

export default Homepage;

const HomepageWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  border-bottom-left-radius: 50px;
  border-top-left-radius: 50px;
  background-color: #f1f8fc;
  height: 1600px;
  ${(props: WidthType) => {
    const setWidth = props.width - 250;
    const setWidthString = setWidth.toString() + 'px';
    return css`
      width: ${setWidthString};
    `;
  }}
  @media (max-width: 414px) {
    display: flex;
    flex-direction: column;
    padding-left: 0;
    width: 100vw;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    height: 100%;
    padding-top: 40px;
    padding-bottom: 100px;
  }
`;

const HeaderComponent = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  width: 1053px;
  max-width: 1053px;
  min-width: 1053px;
  @media (max-width: 414px) {
    min-width: 335px;
    width: 335px;
  }
`;

const ContentWrapper = styled.div``;

const PageTitle = styled.h1`
  font-size: 38px;
  margin-bottom: 8px;
  padding-top: 100px;
  font-family: 'Tiempos';
  @media (max-width: 414px) {
    width: 335px;
    margin-left: 0px;
    padding-top: 0px;
    font-size: 22px;
    font-family: 'Tiempos Headline';
    font-weight: 600;
  }
`;

const BigImg = styled.img`
  width: 500px;
  position: absolute;
  top: 19px;
  right: 0;
  @media (max-width: 414px) {
    display: none;
  }
`;

const TradeText = styled.div`
  color: #100f10;
  font-family: 'Avenir Next';
  font-size: 15px;
  font-weight: 500;
  width: 415px;
  @media (max-width: 414px) {
    width: 335px;
    font-size: 15px;
    font-family: 'Avenir Next';
    font-weight: 500;
  }
`;

const SwapButton = styled.button`
  :focus {
    outline: none;
  }
  border: none;
  background-color: #007d81;
  height: 50px;
  width: 190px;
  border-radius: 4px;
  margin-top: 40px;
  margin-bottom: 40px;
  @media (max-width: 414px) {
    margin-top: 30px;
  }
`;

const PlusSignImage = styled.img`
  height: 20px;
  width: 20px;
  object-fit: contain;
  margin-right: 10px;
`;

const ButtonText = styled.span`
  font-size: 16px;
  color: #fff;
`;

const BottomPanelWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 1056px;
  @media (max-width: 414px) {
    height: 1075px;
    width: 335px;
    flex-direction: column;
  }
`;

type HomepagePropTypes = {
  showResponsiveLogin: () => void;
};

type WidthType = {
  width: number;
};
